(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('BagDetailController', BagDetailController);

    /** @ngInject */
    function BagDetailController($state, $timeout, $stateParams, $q, $window, systemConstants, $localStorage, moment,
                                 StoreService, $scope, $translate, FlyersService, FlyerCategoryService, FlyersCurrencyValue,
                                 ShowcasesService, toastr, Principal, UserInteractModalFactory, ModalFactory, DOMAIN, $rootScope,
                                 BrandService, CustomerService, UserService, paginationConstants, $uibModal, MODAL_CONTENT_TYPES,
                                 ShowcaseSettingsService) {

        var vm = this;
        const DATE_FORMAT = $translate.instant('momentDateFormat');

        vm.$onInit = init;

        vm.loadingMoipAccount = false;
        vm.loadingGetAllFiltersFlyer = false;
        vm.loadingGetBrandsByCurrentStore = false;
        vm.loadingListCategoriesByCurrentStore = false;
        vm.loadingGetTemplates = false;
        vm.loadingGetOwnerCategoryCurrentStore = false;
        vm.loadingGetShowcase = false;

        vm.isLoadingFlyers = false;
        vm.loadingSelection = false;

        function init() {
            $scope.$watchGroup([
                    'vm.loadingMoipAccount',
                    'vm.loadingGetAllFiltersFlyer',
                    'vm.loadingGetBrandsByCurrentStore',
                    'vm.loadingListCategoriesByCurrentStore',
                    'vm.loadingGetTemplates',
                    'vm.loadingGetOwnerCategoryCurrentStore',
                    'vm.loadingGetShowcase'
                ],
                function (newValues) {
                    var isLoading = newValues.some(function (val) {
                        return !!val;
                    });
                    if (!isLoading) {
                        vm.isLoading = false;
                    }
                });

            var locale = $translate.use().toLowerCase();
            vm.sortOptions = getBagSortOptions(locale);
        }

        var userInteractModal;
        var storeId = $localStorage.defaultStore.storeId;
        vm.isImmoContext = $localStorage.defaultStore.immoContext;
        var mainColor = getComputedStyle(document.documentElement).getPropertyValue('--main-color');
        vm.showcaseId = $stateParams.showcaseId;
        vm.isEditMode = !!vm.showcaseId;

        vm.isFiltering = false;
        vm.maxSize = 5;
        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.itemsPerPageOptions = paginationConstants.itemsPerPageOptions;
        vm.totalFlyers = 0;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;
        vm.banners = [];
        vm.haveBanners = false;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;
        vm.selectedBedrooms = [];
        vm.selectedParkingSpots = [];
        vm.selectedBathrooms = [];

        vm.bedrooms = [
            {id: 1, label: "1", value: 1},
            {id: 2, label: "2", value: 2},
            {id: 3, label: "3", value: 3},
            {id: 4, label: "4", value: 4},
            {id: 5, label: "5+", value: 5},
        ];

        vm.parkingSpots = [
            {id: 1, label: "1", value: 1},
            {id: 2, label: "2", value: 2},
            {id: 3, label: "3", value: 3},
            {id: 4, label: "4", value: 4},
            {id: 5, label: "5+", value: 5},
        ];

        vm.bathrooms = [
            {id: 1, label: "1", value: 1},
            {id: 2, label: "2", value: 2},
            {id: 3, label: "3", value: 3},
            {id: 4, label: "4", value: 4},
            {id: 5, label: "5+", value: 5},
        ];

        var bagDefaultImg = $localStorage.hub.bannerPicture;
        var bagMobileDefaultImg = $localStorage.hub.mobileBannerPicture;
        var bagDefaultImgData = '';

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage
        };

        vm.showcase = {
            'backgroundColor': false,
            flyers: [],
            ownerId: null,
            hasCover: false
        };

        vm.saveImageCover = true;
        vm.isPrinting = false;
        vm.tab = 1;
        vm.colors = [];
        vm.sizes = [];
        vm.excludes = [];
        vm.featureds = [];
        vm.tags = [];
        vm.genders = [];

        vm.isLoading = true;

        vm.filters = {
            brands: [],
            colors: [],
            configurations: [],
            sizes: [],
            categories: [],
            genders: [],
            imageOptions: [],
            tags: [],
            type: null,
            isLaunch: null,
            isBasic: null,
            text: ''
        }

        vm.numberFilterSelected = 0;

        vm.selectedConfigurations = [];
        vm.selectedSortByOption = "";

        vm.customerInput = '';

        function clearPaginationInfo() {
            vm.currentPage = 1;
            vm.paginationOptions = {
                page: vm.currentPage - 1,
                size: vm.numPerPage
            };
        }

        vm.onSelectedSortOption = function (newValue) {
            clearPaginationInfo();

            vm.selectedSortByOption = newValue;
            vm.filters.sortBy = vm.selectedSortByOption.value;
            vm.filters.sortDirection = vm.selectedSortByOption.direction;
            loadFlyers();
        }

        vm.onChangeItemsPerPage = function (newValue) {
            vm.numPerPage = newValue;
            clearPaginationInfo();
            vm.changePage();
        };

        vm.closeDropDown = function () {
            $("md-backdrop").trigger('click');
        }

        vm.getSelectedTextGender = function (filter) {
            var genderTranslate = '';
            if (filter[0] === 1) {
                genderTranslate = $translate.instant('flyers.new.form.gender.male');
            }
            if (filter[0] === 2) {
                genderTranslate = $translate.instant('flyers.new.form.gender.female');
            }
            if (filter[0] === 3) {
                genderTranslate = $translate.instant('flyers.new.form.gender.both');
            }
            if (filter.length == 1) {
                return '<span class="highlight">' + genderTranslate + '</span>';
            }
            if (filter.length > 1) {
                var temp = '  +';
                temp += filter.length - 1;
                temp += ' selecionados';
                return '<span class="highlight">' + genderTranslate + '</span>' +
                    '<span>&nbsp</span>' +
                    '<span class="highlight">' + temp + '</span>';
            }
            return '';
        }

        vm.getSelectedTextCategory = function (filter) {
            for (var i = 0; i < vm.categories.length; i++) {
				if (vm.categories[i].key === filter[0]){
		            if (filter.length == 1) {
		                return '<span class="highlight">' + vm.categories[i].title + '</span>';
		            }
		            if (filter.length > 1) {
		                var temp = '  +';
		                temp += filter.length - 1;
		                temp += ' selecionados';

		                return '<span class="highlight">' + vm.categories[i].title + '</span>' +
		                    '<span>&nbsp</span>' +
		                    '<span class="highlight">' + temp + '</span>';
		            }
		            return '';
				}
			}
            return '';
        }

        vm.getSelectedTextBrands = function (filter) {
            for (var i = 0; i < vm.brands.length; i++) {
                if (filter[0] && vm.brands[i].name === filter[0]){
                    if (filter.length == 1) {
                        return '<span class="highlight">' + vm.brands[i].name + '</span>';
                    }
                    if (filter.length > 1) {
                        var temp = '  +';
                        temp += filter.length - 1;
                        temp += ' selecionados';

                        return '<span class="highlight">' + vm.brands[i].name + '</span>' +
                            '<span>&nbsp</span>' +
                            '<span class="highlight">' + temp + '</span>';
                    }
                    return '';
                }
            }
            return '';
        }

        vm.getSelectCheckboxText = function () {
            if (vm.excludes && vm.excludes.length > 0) {
                return $translate.instant('bag.list.selection.options.selected-count',
                    { selected: vm.excludes.length, total: vm.totalFlyers });
            } else {
                return $translate.instant('bag.list.selection.options.all-from-page');
            }
        }

        vm.customers = [];

        vm.customer = {};

        vm.users = [];

        vm.user = {};

        vm.selectionTypes = [
            {
                value: 'ALL',
                translation: 'bag.list.selection.options.all'
            },
            {
                value: 'ALL_FROM_PAGE',
                translation: 'bag.list.selection.options.all-from-page'
            },
            {
                value: 'NONE',
                translation: 'bag.list.selection.options.none'
            }
        ];

        vm.checkIfFilterSelected = function (filterKey, filter) {
            return (vm.filters[filterKey] ? vm.filters[filterKey] : []).indexOf(filter) >= 0 ? true : false;
        }

        vm.updateFilterOrRemove = function (filterKey, filter) {
            if (!vm.filters[filterKey]) {
                vm.filters[filterKey] = [];
            }
            var index = vm.filters[filterKey].indexOf(filter);
            if (index === -1) {
                vm.filters[filterKey].push(filter);
                return;
            }
            vm.filters[filterKey].splice(index, 1);
        }

        vm.checkIfLaunchSelected = function () {
            return vm.filters.isLaunch;
        }

        vm.updateLaunchOrRemove = function () {
            vm.filters.isLaunch = !vm.filters.isLaunch;
        }

        vm.checkIfBasicSelected = function () {
            return vm.filters.isBasic;
        }

        vm.updateBasicOrRemove = function () {
            vm.filters.isBasic = !vm.filters.isBasic;
        }

        vm.checkIfFlyerSelected = function (flyer) {
            var flyerId = getFlyerKey(flyer);
            return vm.excludes.includes(flyerId);
        }

        function getFlyerKey(flyer) {
            if (vm.groupByColorEnabled) {
                return flyer.id + '_' + (flyer.groupingColorId ? flyer.groupingColorId : '<null>');
            }
            return flyer.id;
        }

        vm.refreshSelectedFlyers = function (flyer) {
            var flyerKey = getFlyerKey(flyer);
            var index = vm.excludes.indexOf(flyerKey);
            if (index >= 0) {
                vm.excludes.splice(index, 1);
                return;
            }
            vm.excludes.push(flyerKey);
        }

        vm.removeFromSelectedList = function (flyerKey) {
            var index = vm.excludes.indexOf(flyerKey);
            if (index > -1) {
                vm.excludes.splice(index, 1);
            }
        }

        vm.hasSome = function (selectedList, flyers) {
            if (flyers) {
                return flyers.some(function (flyer) {
                    return selectedList.indexOf(getFlyerKey(flyer)) >= 0;
                });
            }
        };

        vm.isAllFromPageSelected = function () {
            if (vm.flyersFiltered && vm.flyersFiltered.length > 0) {
                return vm.flyersFiltered.every(function (flyer) {
                    return vm.excludes.indexOf(getFlyerKey(flyer)) >= 0;
                });
            }
            return false;
        }

        vm.isIndeterminate = function () {
            return vm.hasSome(vm.excludes, vm.flyersFiltered) && !vm.isAllFromPageSelected();
        }

        vm.selectItemsBy = function (type) {
            if (type === 'ALL') {
                vm.selectAllFromFilter();
            } else if (type === 'ALL_FROM_PAGE') {
                vm.flyersFiltered.forEach(function (flyer) {
                    if (vm.excludes.indexOf(getFlyerKey(flyer)) === -1) {
                        vm.excludes.push(getFlyerKey(flyer));
                    }
                });
            } else if (type === 'NONE') {
                vm.excludes = [];
            }
        }

        vm.selectAllFromFilter = function () {
            vm.loadingSelection = true;
            ShowcasesService.findAllFlyerKeysByFilterBag(vm.filters, vm.groupByColorEnabled).then(function (keys) {
                vm.excludes = _.uniq(keys);
                vm.loadingSelection = false;
            });
        }

        function reconcileSelectionWithFilters() {
            if (!vm.excludes || vm.excludes.length === 0) {
                return;
            }
            vm.loadingSelection = true;
            ShowcasesService.findAllFlyerKeysByFilterBag(vm.filters, vm.groupByColorEnabled).then(function (keys) {
                vm.excludes = vm.excludes.filter(function (key) {
                    return keys.indexOf(key) !== -1;
                });
                vm.loadingSelection = false;
            });
        }

        vm.addPageToList = function () {
            if (vm.isAllFromPageSelected()) {
                vm.excludes = [];
            } else {
                var notIn = vm.flyersFiltered.filter(function (flyer) {
                    return vm.excludes.indexOf(getFlyerKey(flyer)) < 0;
                });
                if (notIn && notIn.length) {
                    for (var i = 0; i < notIn.length; i++) {
                        vm.refreshSelectedFlyers(notIn[i]);
                    }
                } else {
                    vm.excludes = [];
                }

            }
        }

        vm.filterFlyers = function () {
            loadFilters();
            countFilters();

            vm.flyersFiltered = [];
            vm.isFiltering = true;
            vm.filters.type = null;

            vm.isLoadingFlyers = true;
            ShowcasesService.findFlyerByFilterBag(vm.paginationOptions, vm.filters, vm.groupByColorEnabled).then(function (response) {
                vm.isLoadingFlyers = false;
                vm.isFiltering = false;
                vm.totalFlyers = response.totalElements;
                vm.flyersFiltered = response.content;

                var currentPage = response.number;
                var numPerPage = response.size;
                var pageStartCount = (currentPage * numPerPage);
                var pageEndCount = pageStartCount + vm.numPerPage;

                vm.startRegistry = pageStartCount + 1;
                vm.endRegistry = Math.min(pageEndCount, vm.totalFlyers);

                vm.flyersFiltered.map(function (data) {
                    data.stock = data.inventory ? +data.inventory : 0;
                    if (data.details) {
                        data.stock += +data.details.reduce(function (a, b) {
                            return a + +b.inventory
                        }, 0)
                    }
                    vm.getCategoryName(data);
                })
                if (vm.groupByColorEnabled) {
                    vm.flyersFiltered.forEach(function (flyer) {
                        if (flyer.details && flyer.details.length > 0) {
                            flyer.details = flyer.details.filter(function (detail) {
                                return detail.inventory === null || detail.inventory > 0;
                            });
                        }
                    });
                }

                /**
                 * Verifica se o flyer possui estoque
                 */
                vm.flyersFiltered.forEach(function (flyer) {
                    if (flyer.details && flyer.details.length > 0) {

                        flyer.details.every(function (detail) {
                            flyer.hasInventory = detail.inventory === null || (detail.inventory !== null && detail.inventory > 0) ? true : false;
                            return !flyer.hasInventory;
                        });
                    } else {
                        flyer.hasInventory = flyer.inventory === null || (flyer.inventory !== null && flyer.inventory > 0) ? true : false;
                    }
                });
            });
        }

        vm.saveBag = function () {
            ShowcasesService.saveBag({
                showcaseTemplateId: 1,
                backgroundColor: mainColor,
                ownerId: 0,
                hasCover: true,
                userInteract: 'SALE',
                flyers: [],
                excludes: [],
                bagFilters: vm.filters
            });
        }

        vm.goToTabTwo = function () {
            if (!vm.showcase.id) {
                vm.saveBag
            }
        }

        vm.showcase = {
            'backgroundColor': false,
            flyers: [],
            ownerId: null,
            hasCover: false
        };

        vm.listFilter = {
            storeId: storeId,
            activated: null,
            type: null
        };

        vm.getTranslateKey = function (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey);
        };

        vm.openShowcaseModalType = openShowcaseModalType;

        vm.imageSize = 800;

        vm.storeOwnerHasMoipAccount = false;
        storeOwnerHasMoipAccount();
        vm.loadFlyers = loadFlyers;
        vm.dynamicPopover = {
            templateUrl: 'userInteractPopoverTemplate.html',
        };

        vm.coverEdit = true;
        vm.templateIsLoading = true;
        vm.showcases = [1, 2, 3, 4, 5, 6, 7, 8];
        vm.templates = [];
        vm.flyersToLoad = 1;
        vm.isSaving = false;
        vm.isSavingPreview = false;
        vm.showcaseColors = [
            [{
                color: "#201E1E",
                border: 0
            }, {
                color: "#363231",
                border: 0
            }, {
                color: "#4B4544",
                border: 0
            }, {
                color: "#870200",
                border: 0
            }, {
                color: "#05a19c",
                border: 0
            }, {
                color: "#37003C",
                border: 0
            }, {
                color: "#5A1846",
                border: 0
            }, {
                color: "#910D3F",
                border: 0
            }, {
                color: "#C70039",
                border: 0
            }, {
                color: "#263545",
                border: 0
            }],
            [{
                color: "#002A4A",
                border: 0
            }, {
                color: "#01201B",
                border: 0
            }, {
                color: "#015146",
                border: 0
            }, {
                color: "#1A5B28",
                border: 0
            }, {
                color: "#277B25",
                border: 0
            }, {
                color: "#331908",
                border: 0
            }, {
                color: "#D35400",
                border: 0
            }, {
                color: "#DF7F05",
                border: 0
            }, {
                color: mainColor,
                border: 0
            }]
        ];

        loadAllFiltersFlyer();

        vm.goToSettings = function () {
            $state.go('settings');
        }

        vm.tabClick = function (tab) {
            if (vm.showcaseId && tab === 2) {
                vm.filterFlyers();
            } else if (!vm.showcase.name) {
                toastr.warning($translate.instant('bag.error.no-bag-name'));
                return;
            } else if (tab === 2) {
                vm.saveFlyerPreview();
                return;
            }
            vm.tab = tab;
            vm.loadingTab = true;
        }

        function getConfigurationsValues() {
            vm.configurations = [
                {id: 1, label: "flyers.new.form.configurations.launch", code: "launch"},
                {id: 2, label: vm.getTranslateKey('flyers.new.form.configurations.basic'), code: "basic"}
            ];

            if (vm.isImmoContext) {
                vm.configurations.push(
                    {id: 3, label: "flyers.new.form.configurations.delivered", code: "delivered"}
                );
            }
        }

        function getConfigurationByCode(code) {
            return vm.configurations.find(function (conf) {
                return conf.code === code;
            });
        }

        function removeInvalidFilter(key, validOptions, listFilter) {
            var validItens = [];
            if (key && validOptions) {
                validOptions.forEach(function(category) {
                    validItens.push(category[key]);
                });
            } else {
                validItens = validOptions;
            }
            if (listFilter){
                listFilter.forEach(function(obj) {
                    if (!(validItens.includes(obj))) {
                        var index = listFilter.indexOf(obj);
                        listFilter.splice(index, 1);
                    }
                });
            }
        }

        function verifyFilters() {
            removeInvalidFilter('key', vm.categories, vm.filters.categories);
            removeInvalidFilter('name', vm.brands, vm.filters.brands);
            removeInvalidFilter('label', vm.sizes, vm.filters.sizes);
            removeInvalidFilter('label', vm.colors, vm.filters.colors);
        }

        function loadFilters() {
            loadConfigurationsFilter();
            loadDeliveryDateFilter();
            loadMultiSelectFilterByField('selectedBrands', 'brands', 'name');
            loadMultiSelectFilterByField('selectedTags', 'tags', 'label');
            loadMultiSelectFilterByField('selectedGenders', 'genders', 'id');
            loadMultiSelectFilterByField('selectedImageOptions', 'imageOptions', 'value');
            loadMultiSelectFilterByField('selectedCategories', 'categories', 'key');
            loadMultiSelectFilterByField('selectedSizes', 'sizes', 'label');
            loadMultiSelectFilterByField('selectedColors', 'colors', 'label');
            loadMultiSelectFilterByField('selectedBedrooms', 'bedrooms', 'value');
            loadMultiSelectFilterByField('selectedParkingSpots', 'parkingSpots', 'value');
            loadMultiSelectFilterByField('selectedBathrooms', 'bathrooms', 'value');
        }

        function loadDeliveryDateFilter() {
            loadDateFilter('deliverySinceDate', vm.filters.sinceDate);
            loadDateFilter('deliveryUntilDate', vm.filters.untilDate);
        }

        function loadDateFilter(filterKey, dateValue) {
            if (dateValue) {
                vm[filterKey] = moment(dateValue).format(DATE_FORMAT).toString();
            } else {
                vm[filterKey] = '';
            }

        }

        function loadMultiSelectFilterByField(selectedFilterKey, filterKey, optionField) {
            if (vm.filters[filterKey] && vm.filters[filterKey].length > 0) {
                vm[selectedFilterKey] = vm.filters[filterKey].map(function (item) {
                    return vm[filterKey].find(function (option) {
                        return option[optionField] === item;
                    });
                });
            } else {
                vm[selectedFilterKey] = [];
            }
        }

        function loadConfigurationsFilter() {
            if (angular.isArray(vm.selectedConfigurations) && vm.selectedConfigurations.length > 0) {
                vm.filters.isBasic = vm.selectedConfigurations.find(function (item) {
                    return item.code === 'basic';
                } ) !== undefined;
                vm.filters.isLaunch = vm.selectedConfigurations.find(function (item) {
                    return item.code === 'launch';
                } ) !== undefined;
                vm.filters.isDelivered = vm.selectedConfigurations.find(function (item) {
                    return item.code === 'delivered';
                } ) !== undefined;
            } else {
                vm.filters.isBasic = false;
                vm.filters.isLaunch = false;
                vm.filters.isDelivered = false;
            }
        }

        function countFilters(){
            verifyFilters();

            vm.numberFilterSelected =
                (vm.filters.colors ? vm.filters.colors.length : 0) +
                (vm.filters.categories ? vm.filters.categories.length : 0) +
                (vm.filters.brands ? vm.filters.brands.length : 0) +
                (vm.filters.sizes ? vm.filters.sizes.length : 0) +
                (vm.filters.genders ? vm.filters.genders.length : 0) +
                (vm.filters.imageOptions ? vm.filters.imageOptions.length : 0) +
                (vm.filters.tags ? vm.filters.tags.length : 0) +
                (vm.filters.bedrooms ? vm.filters.bedrooms.length : 0) +
                (vm.filters.bathrooms ? vm.filters.bathrooms.length : 0) +
                (vm.filters.parkingSpots ? vm.filters.parkingSpots.length : 0) +
                (vm.filters.sinceDate && vm.filters.untilDate ? 1 : 0) +
                (vm.filters.minMeters && vm.filters.maxMeters ? 1 : 0) +
                (vm.filters.minValue && vm.filters.maxValue ? 1 : 0) +
                (vm.filters.region ? vm.filters.region.length : 0) +
                (vm.filters.isLaunch ? 1 : 0) +
                (vm.filters.isBasic ? 1 : 0) +
                (vm.filters.isDelivered ? 1 : 0);
        }

        function getLoggedUser() {
            Principal.identity().then(function(account) {
                vm.loggedUser = account;
                vm.users.push(account);
                initializeBannersFromAccount(account.accountDTO);
            });
        }

        function initializeBannersFromAccount(accountDTO) {
            vm.haveBanners = (accountDTO && accountDTO.banner) || bagDefaultImg
            if(vm.haveBanners){
                var banner = {
                    'id': 1,
                    'image': accountDTO.banner ? accountDTO.banner.path : bagDefaultImg,
                    'imageMobile': accountDTO.bannerMobile ? accountDTO.bannerMobile.path : bagMobileDefaultImg,
                    'name': '',
                    'link': ''
                };
                vm.banners.push(banner);
            }

        }

        function loadAllFiltersFlyer() {
            vm.loadingGetAllFiltersFlyer = true;
			FlyersService.getAllFiltersFlyer().then(function (response) {
                vm.loadingGetAllFiltersFlyer = false;
				vm.colors = formatSelectOptions(response.data.colors);
				vm.sizes = formatSelectOptions(response.data.sizes);
				vm.featureds = response.data.features;
				vm.tags = formatSelectOptions(response.data.tags);
                vm.genders = [
                    {label: "flyers.new.form.gender.male", id: 1},
                    {label: "flyers.new.form.gender.female", id: 2},
                    {label: "flyers.new.form.gender.both", id: 3},
                ];
                vm.imageOptions = [
                    { id: 1, label: 'flyers.new.form.images.with_image', value:'WITH_IMAGE' },
                    { id: 2, label: 'flyers.new.form.images.no_image', value:'NO_IMAGE' },
                    { id: 3, label: 'flyers.new.form.images.both', value:'BOTH' }
                ];
                getBase64Image(bagDefaultImg);
                getBase64Image(bagMobileDefaultImg);
                loadFilters();

                if (vm.showcaseId) {
                    loadShowcase().then(function () {
                        loadFlyers();
                    });
                } else {

                    vm.showcase.ownerId = storeId;
                    vm.showcase.backgroundColor = mainColor;
                    vm.showcase.showcaseTemplateId = vm.templateId;
                    vm.templateIsLoading = false;
                    if(!vm.showcase.bagFilters || (vm.showcase.bagFilters && !vm.showcase.bagFilters.type)) {
                        vm.filters.type = 'SALE';
                    }
                    loadFlyers();
                    getLoggedUser();
                }
            });

            vm.loadingGetBrandsByCurrentStore = true;
            BrandService.getBrandsByCurrentStore().then(function (response) {
                vm.loadingGetBrandsByCurrentStore = false;
                vm.brands = formatSelectOptions(response.data);
            });

            vm.loadingListCategoriesByCurrentStore = true;
            FlyerCategoryService.listCategoriesByCurrentStore($translate.use()).then(function (response) {
                vm.loadingListCategoriesByCurrentStore = false;
                vm.categories = formatSelectOptions(response.data);
            });

            vm.loadingGetTemplates = true;
            vm.templateId = 1; // Chose the first template as default
            ShowcasesService.getTemplates().then(function (response) {
                vm.loadingGetTemplates = false;
                vm.templates = response;
            });

            vm.loadingGetOwnerCategoryCurrentStore = true;
            StoreService.getOwnerCategoryCurrentStore().then(function (response) {
                vm.loadingGetOwnerCategoryCurrentStore = false;
                vm.storeCategory = response.data;
            });

            getConfigurationsValues();

        }

        function loadShowcase() {
            vm.loadingGetShowcase = true;

            function loadSelectedFlyers() {
                vm.excludes = [];
                if (vm.groupByColorEnabled) {
                    vm.showcase.flyers.forEach(function (showcaseFlyer) {
                        var flyerKey = getFlyerKey(showcaseFlyer);
                        if (vm.excludes.indexOf(flyerKey) === -1) {
                            vm.excludes.push(flyerKey);
                        }
                    });
                } else {
                    if (vm.showcase.flyers && vm.showcase.flyers.length > 0) {
                        vm.showcase.flyers.forEach(function (flyer) {
                            if (vm.excludes.indexOf(flyer.id) === -1) {
                                vm.excludes.push(flyer.id);
                            }
                        });
                    }
                }
            }

            return ShowcasesService.getShowcase(vm.showcaseId).then(function (response) {
                vm.showcase = response;
                vm.customers = vm.showcase.customers;
                vm.users = vm.showcase.users;
                vm.filters = vm.showcase.bagFilters;
                loadSelectedFlyers();
                if (vm.showcase.bagFilters) {
                    if (vm.showcase.bagFilters.isBasic) {
                        var basic = getConfigurationByCode('basic');
                        vm.selectedConfigurations.push(basic)
                    }
                    if (vm.showcase.bagFilters.isLaunch) {
                        var launch = getConfigurationByCode('launch');
                        vm.selectedConfigurations.push(launch)
                    }
                    if (vm.showcase.bagFilters.isDelivered) {
                        var delivered = getConfigurationByCode('delivered');
                        vm.selectedConfigurations.push(delivered)
                    }

                    if (vm.showcase.bagFilters.sinceDate) {
                        vm.deliverySinceDate = moment(vm.showcase.bagFilters.sinceDate).format(DATE_FORMAT);
                    }

                    if (vm.showcase.bagFilters.untilDate) {
                        vm.deliveryUntilDate = moment(vm.showcase.bagFilters.untilDate).format(DATE_FORMAT);
                    }
                }

                if(!vm.showcase.bagFilters || (vm.showcase.bagFilters && !vm.showcase.bagFilters.type)) {
                    vm.filters.type = 'SALE';
                }

                vm.showcase.userInteract = vm.originalUserInteract ? vm.originalUserInteract : vm.showcase.userInteract;

                if(vm.showcase.banners != null && vm.showcase.banners.length > 0) {
                    vm.banners = vm.showcase.banners;
                    vm.haveBanners = true;
                    vm.showcase.banners.forEach(function(banner, i) {
                        vm.banners[i].image = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].cover;

                        if (vm.banners[i].coverMobile) {
                            vm.banners[i].imageMobile = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].coverMobile;
                        }
                    })
                } else if (vm.showcase.hasCover && vm.showcase.coverUrl !== '') {
                    checkImage(function (url) {
                        vm.banners.push({'id': 1, 'image': url, 'name': '', 'link': ''});
                    });
                    vm.haveBanners = true;
                }

                vm.loadingGetShowcase = false;
                loadShowcasesFlyers();
            });
        }

        vm.getProfileName = function(user) {
            if (user) {
                var profiles = user.userProfiles.filter(function (prof) {
                    return prof.storeId === storeId;
                });

                return profiles && profiles.length > 0 ? (profiles[0].profileName) : "";
            } else {
                return '';
            }
        }


        vm.changeTemplate = function (templateId) {
            vm.templateIsLoading = true;
            vm.templateId = templateId;
            loadTemplate().then(function () {
                vm.showcase.showcaseTemplateId = templateId;
                loadFlyersToTemplate(angular.copy(vm.showcase.flyers));
            });
        };

        function changeMaxFlyerPerShowcase() {
            vm.maxFlyersPerShowcase = vm.template.quantityOfRows * (12 / vm.template.row.items[0].size);
        }

        vm.getImageSrc = function (templateId) {
            return 'content/images/templates/' + templateId + '.png';
        };

        function succesPrint(res) {

            if (res.headers["content-disposition"]) {
                var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                var mimeType = res.headers["content-type"];
                filename = filename.replace(/['"]/g, '');
                saveByteArray([res.data], filename, mimeType);
            } else {
                toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
            }

            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
        }

        function errorPrint(response) {
            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
            toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));

        }

        vm.generateTabloid = function () {
            vm.saveFlyer(false, function () {
                if (!vm.showcase.hasCover) {
                    toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                    vm.isSaving = false;
                } else if (vm.showcase.flyers.length < 1) {
                    toastr.error($translate.instant('showcases.messages.errors.blankFlyers'));
                } else if (!vm.showcase.name) {
                    toastr.error($translate.instant('showcases.messages.errors.blankName'));
                } else {
                    vm.isPrinting = true;
                    buildMessageGeneratedTabloid();
                    $rootScope.$emit('waiting-generates-tabloid');
                    ShowcasesService.generateTabloid({
                        showcaseId: Number(vm.showcase.id) || undefined,
                        storeId: (storeId ? storeId + "" : undefined) || undefined,
                        flyers: vm.showcase.flyers.map(function (flyer) {
                            return flyer.id;
                        })
                    }).then(succesPrint, errorPrint);
                }
            });
        }

        function loadShowcasesFlyers() {
            if (vm.showcase.flyers) {
                vm.flyerId = 0;
                if (vm.showcase.showcaseTemplateId) {
                    vm.templateId = vm.showcase.showcaseTemplateId;
                }
                reduceFlyersToMap();
                vm.showcase.flyers.forEach(function (flyer) {
                    vm.getCategoryName(flyer);
                    var random = new Date().getTime();
                    flyer.imagePath = '/flyer/api/' + flyer.id + '/picture?type=large&ts=' + random;
                });
                $q.all(vm.showcase.flyers).then(function (flyers) {
                    loadTemplate().then(function () {
                        loadFlyersToTemplate(flyers);
                    });
                });
            }
        }

        function reduceFlyersToMap() {
            var index = 0;
            vm.flyersMap = vm.showcase.flyers.reduce(function (map, flyer) {
                map[flyer.id] = {
                    name: flyer.name,
                    pos: index
                };
                index++;
                return map;
            }, {})
        }

        function loadFlyerTemplateRows() {
            vm.template.rows = [];
            for (var i = 0; i < vm.template.quantityOfRows; i++) {
                var item = {};
                angular.copy(vm.template.row, item);
                vm.template.rows.push(item);
            };
        }

        function loadFlyersToTemplate(flyers) {
            // loadFlyerTemplateRows();
            $q.all(vm.template.rows).then(function (data) {

                for (var i = 0; i < vm.template.rows.length && flyers.length > 0; i++) {
                    for (var k = 0; k < vm.template.rows[i].items.length && flyers.length > 0; k++) {
                        if (vm.template.rows[i].items[k]) {
                            if (flyers.length > 0) {
                                vm.template.rows[i].items[k].flyer = flyers[0];
                                flyers.splice(0, 1);
                            }
                        }
                    }
                }
            });
            $q.all(vm.template).then(function (data) {
                vm.templateIsLoading = false;
            });

        }

        function loadTemplate() {
            return ShowcasesService.getTemplate(vm.templateId).then(function (response) {
                vm.template = response;
                changeMaxFlyerPerShowcase();
                loadFlyerTemplateRows();

            });
        }

        function openShowcaseModalType() {
            userInteractModal = UserInteractModalFactory.selectUserInterectType(storeId, vm.showcase.userInteract);
            userInteractModal.result.then(function (userInteract) {

                vm.originalUserInteract = angular.copy(vm.showcase.userInteract);
                vm.showcase.userInteract = userInteract;

                vm.listFilter.type = vm.showcase.userInteract;
                if (!(vm.originalUserInteract && vm.originalUserInteract === vm.showcase.userInteract)) {
                    vm.flyersInfo = null;
                    vm.flyersFiltered = [];
                    vm.flyersMap = undefined;
                    vm.showcase.flyers = [];
                    loadFlyers();
                    loadShowcasesFlyers();
                }
            });
        }

        function loadFlyers() {
            vm.filterFlyers();
        }

        vm.getShowcasesFlyer = function () {
            vm.saveFlyer(true);
        }

        vm.goToFlyerByShowkase = function () {
            vm.saveFlyer(true);
        }

        vm.goToList = function () {
            $state.go('bag');
        }

        function collectFilters() {
            collectMultiSelectFilterByField('brands', 'selectedBrands', 'label');
            collectMultiSelectFilterByField('tags', 'selectedTags', 'label');
            collectMultiSelectFilterByField('categories', 'selectedCategories', 'key');
            collectMultiSelectFilterByField('sizes', 'selectedSizes', 'label');
            collectMultiSelectFilterByField('colors', 'selectedColors', 'label');
            collectMultiSelectFilterByField('genders', 'selectedGenders', 'id');
            collectMultiSelectFilterByField('imageOptions', 'selectedImageOptions', 'id');
            collectDeliveryDateFilter();
            collectMultiSelectFilterByField('bathrooms', 'selectedBathrooms', 'value');
            collectMultiSelectFilterByField('bedrooms', 'selectedBedrooms', 'value');
            collectMultiSelectFilterByField('parkingSpots', 'selectedParkingSpots', 'value');
        }

        function collectMultiSelectFilterByField(filterKey, selectedFilterKey, fieldKey) {
            if (vm[selectedFilterKey] && vm[selectedFilterKey].length > 0) {
                vm.filters[filterKey] = vm[selectedFilterKey].map(function (item) {
                    return item[fieldKey];
                });
            } else {
                vm.filters[filterKey] = [];
            }
        }

        function collectDeliveryDateFilter() {
            collectDateFilter('sinceDate', vm.deliverySinceDate);
            collectDateFilter('untilDate', vm.deliveryUntilDate);
        }

        function collectDateFilter(filterField, filterValue) {
            if (angular.isString(filterValue) && filterValue.length > 0) {
                vm.filters[filterField] = moment(
                    filterValue,
                    DATE_FORMAT
                ).toDate();
            } else {
                delete vm.filters[filterField];
            }
        }

        vm.saveFlyerPreview = function (isRedirectToFlyersScreen, callback) {
            vm.showcase.showcaseTemplateId = 1;
            if (vm.showcase.name) {
                vm.isSaving = true;
                vm.showcase.cover = "";
                vm.saveCover(function () {
                    if (vm.showcase.addImageFileDTO.length > 0) {
                        var banners = angular.copy(vm.showcase.addImageFileDTO);
                        vm.showcase.addImageFileDTO.forEach(function (banner, index) {
                            banners[index].nameFile = vm.banners[index].name;
                            banners[index].action = vm.banners[index].link;
                        });
                        vm.showcase.addImageFileDTO = banners;

                        vm.showcase.flyers = [];
                        vm.filters.excludes = vm.excludes;
                        collectFilters();
                        reconcileSelectionWithFilters();
                        vm.showcase.bagFilters = vm.filters;
                        vm.showcase.customers = vm.customers.map(function (item) { return + item.id });
                        vm.showcase.users = vm.users.map(function (item) { return + item.id });

                        if (vm.showcaseId) {
                            vm.isFiltering = true;
                            vm.showcase.bagFilters.apply = true;
                            vm.showcase.customers = vm.customers.map(function (item) { return +item.id });
                            var reversedUsers = vm.users.map(function (item) { return +item.id });
                            vm.showcase.users = reversedUsers.reverse();

                            ShowcasesService.updateShowcase(vm.showcase).then(function (data) {
                                vm.showcase = data;
                                vm.banners = data.banners;
                                vm.showcase.banners.forEach(function(banner, i) {
                                    vm.banners[i].image = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].cover;

                                    if (vm.banners[i].coverMobile) {
                                        vm.banners[i].imageMobile = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].coverMobile;
                                    }
                                })
                                if (isRedirectToFlyersScreen) {
                                    $state.go('bag', {
                                        showcaseId: data.id
                                    });
                                } else {
                                    vm.showcaseId = data.id;
                                    // toastr.success($translate.instant('showcases.messages.update.success'));
                                    vm.isSaving = false;
                                    vm.tabClick(2);
                                }
                                if (callback) {
                                    callback(true);
                                }
                                // vm.showcase.flyers = flyers;
                                vm.isSavingPreview = false;
                            }, function (data) {
                                toastr.error($translate.instant('bag.error.filter'));
                                vm.isSaving = false;
                            }).finally(function () { vm.isSaving = false; });
                        } else {
                            vm.isFiltering = true;

                            var reversedUsers = vm.users.map(function (item) { return +item.id });
                            ShowcasesService.saveBag({
                                showcaseTemplateId: 1,
                                backgroundColor: mainColor,
                                ownerId: 0,
                                hasCover: true,
                                userInteract: 'SALE',
                                flyers: [],
                                bagFilters: vm.filters,
                                name: vm.showcase.name,
                                addImageFileDTO: vm.showcase.addImageFileDTO,
                                customers: vm.customers.map(function (item) { return +item.id }),
                                users: reversedUsers.reverse()
                            }).then(function (data) {
                                vm.showcase = data;
                                vm.showcaseId = data.id;
                                vm.showcase.customers = vm.customers.map(function (item) { return +item.id });
                                vm.showcase.users = vm.users.map(function (item) { return +item.id });
                                vm.tabClick(2);
                            }, function (data) {
                                toastr.error($translate.instant('bag.error.filter'));
                                vm.isSavingPreview = false;
                            }).finally(function () {  vm.isSaving = false;});
                        }
                    } else if (!vm.showcase.cover) {
                        vm.isSaving = false;
                        toastr.warning($translate.instant('Insira um estilo para a mala'));
                    }
                });
            } else if (!vm.showcase.name) {
                toastr.warning($translate.instant('Insira o nome da Mala'));
            }
        }

        vm.saveFlyer = function (isRedirectToFlyersScreen, callback, isSaving) {
            vm.showcase.flyers = [];
            vm.filters.excludes = vm.excludes;

            collectFilters();
            vm.showcase.bagFilters = vm.filters;
            vm.showcase.bagFilters.apply = true;
            vm.isFiltering = true;
            if (vm.showcaseId) {
                vm.saveCover(function () {
                    var banners = angular.copy(vm.showcase.addImageFileDTO);
                    vm.showcase.addImageFileDTO.forEach(function (banner, index) {
                        banners[index].nameFile = vm.banners[index].name;
                        banners[index].action = vm.banners[index].link;
                    });
                    vm.showcase.addImageFileDTO = banners;
                    vm.showcase.customers = vm.customers.map(function (item) { return +item.id });
                    vm.showcase.users = vm.users.map(function (item) { return +item.id });
                    ShowcasesService.updateShowcase(vm.showcase).then(function (data) {
                        vm.showcase = data;
                        vm.banners = vm.showcase.banners;
                        vm.showcase.banners.forEach(function(banner, i) {
                            vm.banners[i].image = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].cover;

                            if (vm.banners[i].coverMobile) {
                                vm.banners[i].imageMobile = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].coverMobile;
                            }
                        })

                        if (isRedirectToFlyersScreen) {
                            $state.go('bag', {
                                showcaseId: data.id
                            });

                            if (vm.isMobile && !vm.isEditMode) {
                                openBagReadyModal(data);
                            } else {
                                toastr.success($translate.instant(vm.getTranslateKey('bag.success.ready')));
                            }
                        } else {
                            toastr.success($translate.instant(vm.getTranslateKey('bag.success.ready')));
                            vm.isSaving = false;
                            vm.isFiltering = false;
                            // Follow the instruction of Jackson, when saves the showcase the state doesn't need to be changed
                            // $state.go('showcases');
                        }
                        if (callback) {
                            callback(true);
                            vm.isFiltering = false;
                        }
                        vm.isFiltering = false;

                    }, function (data) {
                        if (isRedirectToFlyersScreen) {
                            toastr.error($translate.instant('Erro ao tentar atualizar sua mala'));
                            vm.isSaving = false;
                            vm.isFiltering = false;
                        }
                    });
                });
            }
        }

        vm.setBackgroundColor = function (color) {
            vm.showcase.backgroundColor = color;
        }

        vm.getCategoryName = function (flyer) {
            var category = _.find(vm.categories, function(el) {return el.key === flyer.categoryKey});
            if (category) {
                flyer.category = category.title;
            }
        }

        vm.getFlyerCurrency = function (currency) {
            return FlyersCurrencyValue[currency];
        }

        vm.getFlyerImageURL = function (flyer) {
            flyer.imagePath = FlyersService.getFlyerImageURL(flyer.id);
        }

        vm.loadFlyer = function () {
            vm.flyerId++;
            vm.flyersToLoad--;
        }

        vm.checkIfShowcasePublished = function () {
            if (vm.showcase.published) {
                return true;
            } else {
                return false;
            }
        }

        vm.getBackgroundImg = function (flyerId) {
            return ('\'/flyer/api/' + flyerId + '/picture\'');
        }

        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId);
        }

        vm.getTranslateFeatureds = function (featured) {
            return 'flyers.new.form.configurations.' + featured.toLowerCase();
        }

        vm.getTranslateGenders = function (gender) {
            if (gender === 1) {
                return 'flyers.new.form.gender.male';
            }
            if (gender === 2) {
                return 'flyers.new.form.gender.female';
            }
            if (gender === 3) {
                return 'flyers.new.form.gender.both';
            }
            return '';
        }

        function showMessagePublishShowcase() {
            if (!$localStorage.defaultStore.storeNickname) {
                getStoreInfo().then(function (response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    buildMessagePublishShowcase();
                });
            } else {
                buildMessagePublishShowcase();
            }
        }

        function buildMessagePublishShowcase() {
            var url = vm.store && vm.store.redirectURL ? 
                $window.location.protocol + '//' + vm.store.redirectURL : 
                'http://' + $localStorage.defaultStore.storeNickname.toLowerCase() + "." + getDomainNameSufix($window);

            ModalFactory.openModal(null,
                $translate.instant('showcases.messages.publish.successTitle', {
                    showcaseType: $translate.instant('global.showcaseTypes.' + vm.showcase.userInteract)
                }),
                $translate.instant('showcases.messages.publish.successSubtitle', {
                    url: url
                }),
                null, $translate.instant('showcases.messages.publish.goToShowcase'),
                'OK', function () { $window.open(url, '_blank'); },
                null, null, 'icon-ksc-showcasepublished');
        }

        function buildMessageGeneratedTabloid() {
            ModalFactory.openModal(null,
                'showcases.messages.tabloid.readyTabloid',
                null, null, 'OK', null, 'close', null, null, null,
                'showcases.messages.tabloid.ifNotDownloaded', 'showcases.messages.tabloid.clickHere',
                function (callback) {
                    ShowcasesService.generateTabloid({
                        showcaseId: Number(vm.showcase.id) || undefined,
                        storeId: (storeId ? storeId + "" : undefined) || undefined,
                        flyers: vm.showcase.flyers.map(function (flyer) {
                            return flyer.id;
                        })
                    }).then(function (res) {
                        var saveByteArray = (function () {
                            return function (data, name, mimeType) {
                                var blob = new Blob(data, {
                                    type: mimeType
                                });
                                var url = window.URL.createObjectURL(blob);
                                var element = angular.element('<a/>');
                                element.attr({
                                    href: url,
                                    target: '_blank',
                                    download: name
                                });
                                if (document.createEvent) {
                                    var ev = document.createEvent("MouseEvent");
                                    ev.initMouseEvent("click", true /* bubble */, true /* cancelable */, window, null, 0, 0, 0, 0, /* coordinates */
                                        false, false, false, false,
                                        /*
                                         * modifier keys
                                         */
                                        0 /* left */, null);
                                    element[0].dispatchEvent(ev);
                                } else {
                                    element[0].fireEvent("onclick");
                                }
                                setTimeout(function () {
                                    document.body.removeChild;
                                    window.URL.revokeObjectURL(url);
                                }, 200);
                            };
                        }());
                        if (res.headers["content-disposition"]) {
                            var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                            var mimeType = res.headers["content-type"];
                            filename = filename.replace(/['"]/g, '');
                            saveByteArray([res.data], filename, mimeType);
                        } else {
                            toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
                        }
                        vm.isPrinting = false;
                        callback();
                    }, function (response) {
                        vm.isPrinting = false;
                        callback();
                    });
                }, 'width: 143px; height: 170px;', 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/' + $rootScope.urlImage + '/download-tabloide.png');
        }

        function storeOwnerHasMoipAccount() {
            vm.loadingMoipAccount = true;
            Principal.storeOwnerHasMoipAccount().then(function (responseMoipAccount) {
                vm.storeOwnerHasMoipAccount = responseMoipAccount.data != null && responseMoipAccount.data.moipLogin != null;
                vm.loadingMoipAccount = false;
            });
        }

        vm.publishShowcase = function () {
            vm.isPublishing = true;
            if (!vm.showcase.hasCover && vm.coverEdit) {
                toastr.warning($translate.instant('showcases.messages.errors.blankCover'));
                vm.isSaving = false;
                vm.isPublishing = false;
            } else if (vm.showcase.flyers.length < 1) {
                toastr.warning($translate.instant('showcases.messages.errors.blankFlyers'));
                vm.isPublishing = false;
                vm.isSaving = false;
            } else if (!vm.showcase.name) {
                toastr.warning($translate.instant('showcases.messages.errors.blankName'));
                vm.isPublishing = false;
                vm.isSaving = false;
            } else {
                vm.saveFlyer(false, function () {
                    ShowcasesService.publishShowcase(vm.showcase.id).then(function (data) {
                        vm.isPublishing = false;
                        showMessagePublishShowcase();
                        $state.go('showcases');
                    }, function (data) {
                        if (data.headers("errorKey")) {
                            toastr.error($translate.instant('showcases.messages.publish.errors.' + data.headers("errorKey")));
                        } else {
                            toastr.error($translate.instant('showcases.messages.publish.errors.genericError'));
                        }

                        vm.isPublishing = false;
                    });
                });
            }
        }

        vm.openInput = function (evt) {
            document.getElementById('fileInput').click();
        }

        vm.getPreviewURL = function (showcase) {
            if (showcase.id) {
                vm.openPreviewURL();
            } else {
                if (vm.saveFlyerPreview(false, function (data) {
                    if (data) {
                        $timeout(function (data) {
                            vm.openPreviewURL();
                        }, 1000);
                    }
                }));
            }
        };

        vm.openPreviewURL = function () {
            var url = vm.store && vm.store.redirectURL ? 
                $window.location.protocol + '//' + vm.store.redirectURL : 
                'http://' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window);
            $window.open(url + '/preview/' + vm.showcase.id, '_blank');
        };

        function checkImage(callback) {
            var image = new Image();
            image.onload = function () {
                if (this.width > 0) {
                    callback(vm.showcase.coverUrl);
                }
            }
            image.onerror = function () {
                callback(bagDefaultImg);
            }
            image.src = vm.showcase.coverUrl;
        }

        var handleFileSelect = function (evt) {

            var file = evt.currentTarget.files[0];
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    vm.imageUpload = evt.target.result;
                    loadImageToCroppieByBase64(evt.target.result);
                });
            };
            reader.readAsDataURL(file);
        };

        vm.initShowcase = function () {
            angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
        };

        var getBase64Image = function (url) {
            var img = new Image();
            img.setAttribute('crossOrigin', 'anonymous');
            img.onload = function () {
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL("image/png");
                bagDefaultImgData = dataURL;
            }
            img.src = url
        }

        vm.saveCover = function (callback) {
            vm.showcase.addImageFileDTO = [];
            if(vm.banners && vm.banners.length == 0) {
                vm.banners = [{'image': bagDefaultImgData, 'name': '', 'link': ''}];
            }

            var arr = Array.from(Array(vm.banners.length).keys());
            var aux = [];
            var index = 0;
            var orderNumber = 0;
            var blob = dataURItoBlob(vm.banners[index].image);
            var mobileImage = vm.banners[index].imageMobile;
            saveFlyerMultiImage(blob, arr, aux, index, orderNumber, mobileImage, callback);
        }

        function saveFlyerMultiImage(blob, arr, aux, i, orderNumber, hasMobileImage, callback) {
            if (i === vm.banners.length) return;

            hasMobileImage = vm.banners[i].imageMobile;
            blob = dataURItoBlob(vm.banners[i].image);

            FlyersService.saveFlyerMultiImage(blob, i).then(function (response) {
                $timeout(function () {
                    if (response.data) {
                        aux.push('');
                        vm.showcase.hasCover = true;
                        if (hasMobileImage) {
                            var blobImageMobile = dataURItoBlob(vm.banners[i].imageMobile);
                            orderNumber = orderNumber + 1;
                            FlyersService.saveFlyerMultiImage(blobImageMobile, orderNumber).then(function (responseMobile) {
                                if (responseMobile) {
                                    response.data.mobileImageFile = responseMobile.data;
                                    arr[response.data.orderNumber] = response.data;
                                    if (aux.length === vm.banners.length) {
                                        vm.showcase.addImageFileDTO = arr;
                                        callback();
                                    }
                                    i = i + 1;
                                    saveFlyerMultiImage(blob, arr, aux, i, orderNumber, hasMobileImage, callback);
                                }
                            });
                        } else {
                            response.data.hasMobileImage = false;
                            arr[response.data.orderNumber] = response.data;
                            orderNumber = orderNumber + 1;
                            if (aux.length === vm.banners.length) {
                                vm.showcase.addImageFileDTO = arr;
                                callback();
                            }
                            i = i + 1;
                            saveFlyerMultiImage(blob, arr, aux, i, orderNumber, hasMobileImage, callback);
                        }
                    } else {
                        toastr.error($translate.instant('flyers.messages.create.error'));
                    }
                    vm.loadingImage = false;
                });
            }, function (response) {
                toastr.error($translate.instant('flyers.messages.create.image.uploadError'));
                vm.loadingImage = false;
            });
        }

        function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {
                type: mimeString
            });
        }

        vm.changePage = function () {
            vm.paginationOptions.page = vm.currentPage - 1;
            vm.filterFlyers();
        }

        window.onDesignPublishCallback = function (data) {
            var exportUrl = data.exportUrl;
            var designId = data.designId;
            loadImageToCroppieByURLCanvas(exportUrl);
            //sendDataViaAjax (exportUrl, designId);
        }

        $scope.$on("$destroy", function () {
            if (!angular.isUndefined(userInteractModal)) {
                userInteractModal.close();
            }
        });

        vm.changeCustomer = function (value) {
            if (value) {
                vm.customerInput = value.trim();
            } else {
                vm.customerInput = null;
            }
        }

        vm.selectedCustomer = function (item) {
            if (item) {
                var customerFinded = vm.customers.find(function (c) { return c.id == item.originalObject.id });
                if (!customerFinded) {
                    vm.customers.push(item.originalObject)
                }
            }
        }

        vm.changeUser = function (value) {
            if (value) {
                vm.userInput = value.trim();
            } else {
                vm.userInput = null;
            }
        }

        vm.selectedUser = function (item) {
            if (item) {
                var userFinded = vm.users.find(function (c) { return c.id == item.originalObject.id });
                if (!userFinded) {
                    vm.users.push(item.originalObject)
                }
            }
        }

        vm.removeUser = function (user) {
            vm.users = vm.users.filter(function(item) { return item.id != user.id })
        }

        vm.requestParams = function (query) {
            return {
                page: 0,
                size: 10,
                storeId: storeId,
                search: query
            }
        }

        vm.removeCustomer = function (customer) {
            if (customer) {
                vm.customers = vm.customers.filter(function(item) { return item.id != customer.id })
            }
        }

        vm.createCustomer = function (typedName) {
            vm.openCreateCustomerModal(typedName);
        }

        vm.openCreateCustomerModal = function (typedName) {
            return $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return {
                            title: $translate.instant('global.form.createCustomer'),
                            cancelButtonText: $translate.instant('global.messages.remove.cancel'),
                            confirmButtonText: $translate.instant('communication.create'),
                            customer: {
                                fullName: typedName
                            },
                            type: MODAL_CONTENT_TYPES.CUSTOMER
                        }
                    }
                }
            }).result.then(function (customer) {
                if (!customer || !customer.id) {
                    return;
                }
                vm.selectedCustomer = customer;
                vm.customers[0] = vm.selectedCustomer;
            });
        }

        vm.clearAutocompleteField = function() {
            var input = document.getElementById("customer_value");
            input.value = "";
        }

        function formatModalFilters(filters) {
            if (!filters) return null;

            var sizes = [];
            if (filters.sizes.length > 0) {
                filters.sizes.map(function(size) { sizes.push(size.label) });
            }
            filters.sizes = sizes;

            vm.selectedConfigurations = [];
            if(filters.configurations.length > 0) {
                var configurations = [];
                filters.configurations.map(function(config) { configurations.push(config.code)});

                var launchConfiguration = getConfigurationByCode('launch');
                if(launchConfiguration && configurations.indexOf(launchConfiguration.code) > -1) {
                    filters.isLaunch = true;
                    vm.selectedConfigurations.push(launchConfiguration);
                }

                var basicConfiguration = getConfigurationByCode('basic');
                if(basicConfiguration && configurations.indexOf(basicConfiguration.code) > -1) {
                    filters.isBasic = true;
                    vm.selectedConfigurations.push(basicConfiguration);
                }

                var deliveredConfiguration = getConfigurationByCode('delivered');
                if(deliveredConfiguration && configurations.indexOf(deliveredConfiguration.code) > -1) {
                    filters.isDelivered = true;
                    vm.selectedConfigurations.push(deliveredConfiguration);
                }
            } else {
                filters.isLaunch = false;
                filters.isBasic = false;
                filters.isDelivered = false;
            }

            var genders = [];
            if (filters.genders.length > 0) {
                filters.genders.map(function(gender) { genders.push(gender.id) });
            }
            filters.genders = genders;

            var imageOptions = filters.imageOptions;
            if (!angular.isArray(imageOptions)) {
                imageOptions = imageOptions ? [imageOptions] : [];
            }
            filters.imageOptions = imageOptions.map(function (opt) {
                return opt.value || opt;
            });

            var brands = [];
            if (filters.brands.length > 0) {
                filters.brands.map(function(brand) { brands.push(brand.label)});
            }
            filters.brands = brands;

            var colors = [];
            if (filters.colors.length > 0) {
                filters.colors.map(function(color) { colors.push(color.label) });
            }
            filters.colors = colors;

            var categories = [];
            if (filters.categories.length > 0) {
                filters.categories.map(function(category) { categories.push(category.key) });
            }
            filters.categories = categories;

            var tags = [];
            if (filters.tags.length > 0) {
                filters.tags.map(function(tag) { tags.push(tag.label) });
            }
            filters.tags = tags;

            var bedrooms = [];
            if (filters.bedrooms.length > 0) {
                filters.bedrooms.map(function(bedroom) { bedrooms.push(bedroom.value) });
            }
            filters.bedrooms = bedrooms;

            var bathrooms = [];
            if (filters.bathrooms.length > 0) {
                filters.bathrooms.map(function(bathroom) { bathrooms.push(bathroom.value) });
            }
            filters.bathrooms = bathrooms;

            var parkingSpots = [];
            if (filters.parkingSpots.length > 0) {
                filters.parkingSpots.map(function(parkingSpot) { parkingSpots.push(parkingSpot.value) });
            }
            filters.parkingSpots = parkingSpots;

            if (filters.sinceDate) {
                filters.sinceDate = moment(filters.sinceDate, DATE_FORMAT).toDate();
            } else {
                delete filters.sinceDate;
            }

            if (filters.untilDate) {
                filters.untilDate = moment(filters.untilDate, DATE_FORMAT).toDate();
            } else {
                delete filters.untilDate;
            }

            if (filters.hasPromotionalPrice && typeof filters.hasPromotionalPrice === 'object') {
                filters.hasPromotionalPrice = filters.hasPromotionalPrice.value;
            }

            return filters;
        }

        function formatOptionsFilters() {
            vm.sizes = formatSelectOptions(vm.sizes);
            vm.colors = formatSelectOptions(vm.colors);
            vm.tags = formatSelectOptions(vm.tags);
        }

        vm.openFiltersModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                controllerAs: 'vm',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return {
                            title: $translate.instant('flyers.filters.modalTitle'),
                            cancelButtonText: $translate.instant('flyers.button.cancel'),
                            confirmButtonText: $translate.instant('flyers.filters.apply'),
                            options: {
                                categories: vm.categories,
                                brands: vm.brands,
                                colors: vm.colors,
                                sizes: vm.sizes,
                                bedrooms: vm.bedrooms,
                                bathrooms: vm.bathrooms,
                                parkingSpots: vm.parkingSpots,
                                configurations: vm.configurations,
                                sortOptions: vm.sortOptions,
                                numPerPage: vm.numPerPage,
                                itemsPerPageOptions: vm.itemsPerPageOptions,
                                tags: vm.tags,
                                selectedSort: vm.selectedSortByOption,
                                canChangeView: false,
                                isBagFilter: true

                            },
                            filters: vm.filtersToModal(),
                            list: vm.listFilter,
                            isImmoContext: vm.isImmoContext,
                            type: MODAL_CONTENT_TYPES.FILTERS
                        }
                    }
                },
            }).result.then(function (response) {
                formatOptionsFilters();
                if (response) {
                    vm.numberFilterSelected = response.totalFilters;
                    vm.filters = formatModalFilters(response.selectedFilters);
                    loadFilters();
                    reconcileSelectionWithFilters();

                    if (response.numPerPage && response.numPerPage !== vm.numPerPage) {
                        vm.numPerPage = response.numPerPage;
                        vm.paginationOptions.page = vm.currentPage - 1;
                        vm.paginationOptions.size = vm.numPerPage;
                    }

                    if (response.sortSelected && response.sortSelected !== vm.selectedSortByOption) {
                        vm.selectedSortByOption = response.sortSelected;
                        vm.listFilter.sortBy = vm.selectedSortByOption.value;
                        vm.listFilter.sortDirection = vm.selectedSortByOption.direction;
                    }
                    loadFlyers();
                }
            });
        }

        vm.filtersToModal = function () {
            var modalFilters = angular.copy(vm.filters);
            var configurations = [];
            if(modalFilters.isBasic) configurations.push({"label":"flyers.new.form.configurations.basic","id":2, "code": "basic"})
            if(modalFilters.isLaunch) configurations.push({"label":"flyers.new.form.configurations.launch","id":1, "code": "launch"})
            if(modalFilters.isDelivered) configurations.push({"label":"flyers.new.form.configurations.delivered","id":3, "code": "delivered"})
            modalFilters.configurations = configurations;
            return modalFilters
        }

        vm.openAddBannersModal = function () {
            // Get current user account for banner images
            var userAccount = null;
            if (vm.users.length > 0) {
                userAccount = vm.users.find(function (user) {
                    return (
                        user.accountDTO &&
                        (user.accountDTO.banner || user.accountDTO.bannerMobile)
                    );
                });
            }

            vm.filtersConversationModal = $uibModal
                .open({
                    templateUrl:
                        "app/admin/showcases/banner-modal/banners_modal.html",
                    controller: "BannersModalController",
                    windowClass: "modal-center",
                    windowTopClass: "center-modal",
                    controllerAs: "vm",
                    size: "lg",
                    keyboard: false,
                    resolve: {
                        banners: function () {
                            return vm.banners;
                        },
                        userAccount: function () {
                            return userAccount;
                        },
                    },
                })
                .result.then(function (response) {
                    if (response) {
                        var carousel = document.getElementById("carousel");
                        var height = carousel.clientHeight;
                        carousel.style.minHeight = height + "px";

                        vm.banners = response.banners;
                        vm.haveBanners = true;
                    }
                });
        };

        vm.getCurrencyPrefix = function(flyer) {
            var key = flyer.currency ? flyer.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            return config.prefix;
        }

        function openBagReadyModal(createdBag) {
            vm.bagReadyModal = $uibModal.open({
                templateUrl: 'app/admin/bag/ready-modal/bag-ready-modal.html',
                controller: 'BagReadyModalController',
                windowClass: 'alt-side-modal',
                windowTopClass: 'bag-create-ready',
                backdrop: 'static',
                controllerAs: 'vm',
                keyboard: false,
                resolve: {
                    createdBag: function () {
                        return createdBag;
                    }
                },
            })
        }

        function loadShowcaseSettings() {
            return ShowcaseSettingsService.getByStoreId($localStorage.defaultStore.storeId).then(function (settings) {
                if (settings && settings.data) {
                    vm.groupByColorEnabled = settings.data.groupByColorEnabled;
                }
            });
        }

        function getBagSortOptions(locale) {
            if (vm.isImmoContext) {
                return getImmoBagSortOptions(locale);
            }

            if (vm.groupByColorEnabled === undefined) {
                loadShowcaseSettings().then(function() {
                    vm.sortOptions = getRetailBagSortOptions(locale);
                });
            } else {
                vm.sortOptions = getRetailBagSortOptions(locale);
            }
        }

        function getImmoBagSortOptions(locale) {
            return paginationConstants.immoSortOptions[locale].filter(filterBagSortOptions);
        }

        function getRetailBagSortOptions(locale) {
            var sortOptions;
            if (vm.groupByColorEnabled) {
                sortOptions = paginationConstants.groupByColorSortOptions[locale].filter(filterBagSortOptions);
            } else {
                sortOptions = paginationConstants.sortOptions[locale].filter(filterBagSortOptions);
            }
            return sortOptions;
        }

        function filterBagSortOptions(sortOption) {
            if (vm.isImmoContext) {
                return sortOption.value !== "isBasic" && sortOption.value !== "discountValue" &&
                    sortOption.value !== "bestSellers" && sortOption.value !== "inventory";
            } else {
                return sortOption.value !== 'inventory';
            }
        }
    }
})();
